// src/services/produtos/ProdutoFiltroService.js
export const normalizarTextoProduto = (texto) => String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');

export const obterIniciaisProduto = (descricao) => {
    const palavras = normalizarTextoProduto(descricao).match(/[a-z0-9]+/g) || [];

    return palavras.map(palavra => palavra.charAt(0)).join('');
};

export const produtoCorrespondeFiltro = (descricao, filtro) => {
    const descricaoNormalizada = normalizarTextoProduto(descricao);
    const filtroNormalizado = normalizarTextoProduto(filtro);

    if (!filtroNormalizado) {
        return true;
    }

    const filtroIniciais = filtroNormalizado.replace(/\s/g, '');

    return descricaoNormalizada.includes(filtroNormalizado) ||
        obterIniciaisProduto(descricaoNormalizada).includes(filtroIniciais);
};
